import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* paymentUnlink(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_UNLINK_REQUEST
    });

    if (!!action.payload?.charge) {
      yield call(Http.put, `payment/${action.payload?.payment?.id}/unlink/${action.payload?.charge?.id}`);
    } else {
      yield call(Http.put, `payment/${action.payload?.payment?.id}/unlink/${null}`);
    }

    yield put({
      type: Constants.GLOBAL_PAYMENT_UNLINK_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-unlinked-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UNLINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentUnlink() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_UNLINK_START, paymentUnlink);
}
